const preguntas = [
  {
    textButtom: 'Empecemos ahora',
    grupo: [],
    textoIntermedio: `<div class="contenedorTexto"><h3 class="titleQuestion">Madurez digital empresarial</h3><p class="textoIntermedioCustom">
   En el actual escenario digital, las MiPymes en Latinoamérica tienen ante sí una oportunidad de crecimiento sin precedentes, con expectativas de que la economía digital alcance $1.2 billones para 2025 <a href="https://publications.iadb.org/es/economia-digital-en-america-latina-y-el-caribe-situacion-actual-y-recomendaciones"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer"> (BID)</a>. La digitalización no solo promete un aumento de ingresos de hasta un 26%, según <a href="https://www.mckinsey.com/featured-insights/destacados/estrategia-para-un-mundo-digital/es"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">McKinsey</a>, sino también mayor eficiencia y acceso a nuevos mercados.
No obstante, desafíos como la escasez de talento digital y una inversión limitada en I+D, donde solo el 40% de las MiPymes tienen estrategias digitales <a href="https://scioteca.caf.com/bitstream/handle/123456789/1766/La economía digital y las industrias digitales basadas en el conocimiento.pdf?sequence=1#:~:text="  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(CAF)</a>, destacan la necesidad urgente de adaptación.</br></br>
Es vital comenzar con una evaluación de madurez digital, un primer paso esencial para liderar en el nuevo entorno económico digital.
    </p></div>`,
  },
  {
    textoPosicionY: 'Número de colaboradores',
    textoPosicionX: 'Tamaño de empresa',
    textButtom: '',
    grupo: [
      {
        title: 'Datos clave',
        tipo: 'select',
        pregunta:
          '¿Cuál es el sector o industria en la que se centra tu empresa?',
        opciones: [
          'Agricultura y silvicultura',
          'Alimentos y bebidas',
          'Arquitectura y construcción',
          'Artes y cultura',
          'Automoción',
          'Banca y finanzas',
          'Biotecnología',
          'Comercio al por mayor y al por menor',
          'Comunicaciones',
          'Consultoría de gestión y servicios empresariales',
          'Defensa y espacio',
          'Educación y formación',
          'Electrónica y semiconductores',
          'Energetico (incluye energías renovables)',
          'Entretenimiento y medios',
          'Farmacéutico',
          'Gobierno y sector público',
          'Hostelería y turismo',
          'Informática y tecnología de la información',
          'Ingeniería y manufactura',
          'Inmobiliaria',
          'Logística y transporte',
          'Materiales y productos químicos',
          'Minería y extracción',
          'Moda y textiles',
          'Petróleo y gas',
          'Productos de consumo',
          'Productos industriales',
          'Publicidad y marketing',
          'Recursos humanos y reclutamiento',
          'Salud y servicios sociales',
          'Seguridad y vigilancia',
          'Seguros',
          'Servicios ambientales y de gestión de residuos',
          'Servicios jurídicos',
          'Servicios públicos y suministros',
          'Tecnología y equipos médicos',
          'Telecomunicaciones',
          'Transporte marítimo y construcción naval',
          'Videojuegos',
        ],
        respuesta: '',
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          '¿Cuál es el número de colaboradores que integran tu empresa?',
        min: 0,
        max: 300,
        respuesta: 10, // Un valor predeterminado razonable podría ser el punto medio
        textMin: '0 empleado',
        textMax: '300+ empleados',
      },
    ],
    textoIntermedio: `
    <p class="textoIntermedioCustom">
       La <a href="https://www.cepal.org/es/temas/pymes/acerca-microempresas-pymes" class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">ONU</a> señala que las MiPyme representan el 90% de las empresas, entre el 60 y el 70% del empleo y el 50% del PIB mundial, por lo que enfrentan el desafío de digitalizarse para fortalecer su posición global. Sin embargo,<a href="https://www.ey.com/es_co/transformacion-con-sentido/nuevo-ritmo-de-madurez-digital#:~:text=De acuerdo con el estudio%2C Latinoamérica se,supuesto de que para alcanzarla plenamente es"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer"> EY </a> asegura que  Latinoamérica se ubica en un nivel de madurez de 61.16 en una escala de 100 puntos. Este proceso de digitalización es vital para impulsar su crecimiento, innovación e inclusión, ampliando sus horizontes más allá de las fronteras regionales.
       </p>
    `,
  },
  {
    textButtom: '',
    textoPosicionY: 'Adaptabilidad de estrategia',
    textoPosicionX: 'Alineación e integración de estrategia',
    grupo: [
      {
        title: 'Estrategia empresarial',
        tipo: 'range',
        pregunta: `Responde en una escala de 0 a 100 <br/>¿Está alineada la estrategia digital con los objetivos generales de tu empresa?`,
        min: 0,
        max: 100,
        textMin: 'No están alineados o no hay estrategia',
        textMax: 'Totalmente alineados',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          'Considerando los cambios tecnológicos y de mercado, ¿qué tan adaptable encuentras tu estrategia empresarial?',
        min: 0,
        max: 100,
        textMin: 'Poco adaptable',
        textMax: 'Muy adaptable',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">En Latinoamérica, el 54% de las empresas poseen una estrategia digital clara <a href="https://www.youtube.com/watch?v=SfRp4koRymk"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(IDC, 2023)</a>, representando un progreso significativo. No obstante, apenas el 38% ha integrado por completo la tecnología en sus operaciones <a href="https://assets.ey.com/content/dam/ey-sites/ey-com/es_mx/topics/digital/transformacion-con-sentido-digital-2022-ey-latinoamerica.pdf" class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(EY, 2022)</a>. Sin embargo, con solo el 44% de las organizaciones demostrando madurez alta en iniciativas digitales estratégicas <a href="https://www.deloitte.com/global/en/our-thinking/insights/topics/digital-transformation/digital-transformation-value-roi.html"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(Deloitte,2023)</a>, por lo que existe un amplio panorama de potencial y oportunidad de crecimiento sin explotar.</p>',
  },
  {
    textoPosicionY: 'Frecuencia de actualización',
    textoPosicionX: 'Eficiencia de infraestructura',
    textButtom: '',
    grupo: [
      {
        title: 'Infraestructura tecnológica',
        tipo: 'range',
        pregunta:
          '¿Qué tan eficientemente la infraestructura tecnológica de tu empresa soporta todas las operaciones y estrategias de crecimiento?',
        min: 0,
        max: 100,
        textMin: 'Poco eficiente',
        textMax: 'Completamente eficiente',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          '¿La infraestructura tecnológica de tu empresa se actualiza frecuentemente?',
        min: 0,
        max: 100,
        textMin: 'Poco frecuente',
        textMax: 'Muy frecuente',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">En Latinoamérica, un 70% de la población tiene acceso a internet según <a href="https://www.cepal.org/sites/default/files/publication/files/46766/S2000991_es.pdf"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">CEPAL (2023)</a>, pero apenas el 23% de las empresas adoptan tecnologías como Big Data, IA y Cloud Computing, indica <a href="https://www.ey.com/es_co/news/2022/02/analitica-de-datos-consideraciones-empresas-transformacion-digit"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer"> EY (2022)</a>. Por lo que se espera que los gastos en TI en LATAM crecerá en 5% en este 2024 <a href="https://www.idc.com/getdoc.jsp?containerId=prLA51751624" class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(IDC, 2023)</a>, momento crucial para maximizar el retorno de estas inversiones.</p>',
  },
  {
    textoPosicionY: 'Fomento de la Innovación',
    textoPosicionX: 'Apoyo al Crecimiento',
    textButtom: '',
    grupo: [
      {
        title: 'Cultura digital',
        tipo: 'range',
        pregunta:
          '¿Qué tanto se fomenta la innovación dentro de tu organización?',
        min: 0,
        max: 100,
        textMin: 'Muy poco',
        textMax: 'Mucho',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          'En tu organización, ¿Se apoya el crecimiento personal y profesional de habilidades digitales?',
        min: 0,
        max: 100,
        textMin: 'Muy poco',
        textMax: 'Mucho',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">A pesar de que el 45% de las empresas <a href=" https://assets.ey.com/content/dam/ey-sites/ey-com/en_uk/topics/workforce/ey-reframing-your-employee-value-proposition-v3.pdf#:~:text=URL%3A https%3A%2F%2Fassets.ey.com%2Fcontent%2Fdam%2Fey"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(EY, 2022)</a> implementan programas de capacitación en habilidades digitales, solo un 21% de los empleados considera tener las competencias necesarias para su trabajo <a href="https://www.idc.com/getdoc.jsp?containerId=US49150623" class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(IDC, 2023)</a>, señalando un margen para impulsar la innovación. Aunque solo el 28% de las organizaciones promueven activamente una cultura innovadora <a href="https://www.youtube.com/watch?v=qqD9KOK5akY"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(CAF, 2023)</a>, el 73% de los líderes entiende su relevancia. Sin embargo, únicamente el 40% está actuando para establecer dicha cultura (IDC, 2023).</p>',
  },
  {
    textoPosicionY: 'Agilidad en implementación de tecnología',
    textoPosicionX: 'Equipos dedicados a la innovación',
    textButtom: '',
    grupo: [
      {
        title: 'Capacidad organizacional',
        tipo: 'range',
        pregunta:
          '¿Se destinan personas o equipos a la innovación o a la implementación de soluciones tecnológicas? ',
        min: 0,
        max: 100,
        textMin: 'Poco',
        textMax: 'Mucho',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          '¿Cómo calificas la agilidad de tu empresa en la implementación de tecnologías o procesos digitales?',
        min: 0,
        max: 100,
        textMin: 'Nada ágil',
        textMax: 'Extremadamente ágil',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">El 58% de las empresas carecen de una estructura adecuada para la digitalización <a href="https://www.ey.com/es_co/transformacion-con-sentido/nuevo-ritmo-de-madurez-digital"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(EY, 2022)</a>, enfrentando dificultades en la gestión del cambio, con solo el 39% con procesos efectivos <a href="https://scioteca.caf.com/bitstream/handle/123456789/1059/Observatorio CAF del ecosistema digital.pdf?sequence=7&isAllowed=y"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(CAF, 2023)</a>. Además, persiste la escasez de talento digital, señalando la necesidad de más profesionales capacitados <a href="https://publications.iadb.org/es/talento-digital-en-el-peru-2022-que-demanda-el-mercado-laboral-resultados-de-una-muestra-de"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer"> (BID, 2023)</a>.</p>',
  },
  {
    textoPosicionY: 'Medición del éxito de tus estrategias',
    textoPosicionX: 'Efectividad de tus estrategias de marketing digital',
    textButtom: '',
    grupo: [
      {
        title: 'Posicionamiento de marca',
        tipo: 'range',
        pregunta:
          '¿Cómo calificas  la efectividad de tu empresa en estrategias de marketing digital y redes sociales para el posicionamiento de marca?',
        min: 0,
        max: 100,
        textMin: 'Poco efectivas',
        textMax: 'Muy efectivas',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          '¿Se realizan mediciones periódicas y fiables del éxito de las estrategias de marketing digital? ',
        min: 0,
        max: 100,
        textMin: 'Ninguna medición',
        textMax: 'Mediciones precisas',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">En 2023, el 75% de las empresas en Latinoamérica aprovecharon las redes sociales, asignando solo el 10% de su presupuesto de marketing a esta área (<a href="https://wearesocial.com/es/blog/2024/01/digital-2024-5-billiones-de-usuarios-en-social-media/#:~:text=Digital 2024 es un reporte de más,social. Más puntos destacados del reporte" class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">We Are Social,Hootsuite</a>; <a href="https://www.hubspot.com/hubfs/[SPANISH] - Social media trend report 2023/social_trends_report_2023_V5_FINAL (2).pdf?hubs_signup-url=offers.hubspot.es%252Finforme-tendencias-redes-sociales-2023&hubs_signup-cta=Descargar%2520ahora&hubs_offer=offers.hubspot.es%252Finforme-tendencias-redes-sociales-2023"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">HubSpot</a>). A pesar de una madurez media en estrategias omnicanal, la región aún no explota plenamente sus ventajas: un crecimiento del 70% en la satisfacción del cliente, un 65% en retención y un aumento del 60% en ventas <a href="https://www.onestock-retail.com/es/blog/forrester-onestock-omnicanal-es/"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(Forrester)</a>. Es crucial desarrollar experiencias de marca completas y memorables.</p>',
  },
  {
    textoPosicionY: 'Personalización de la Experiencia',
    textoPosicionX: 'Satisfacción del Cliente',
    textButtom: '',
    grupo: [
      {
        title: 'Experiencia del cliente',
        tipo: 'range',
        pregunta:
          '¿Cómo calificas el nivel de satisfacción general de tus clientes con las interacciones digitales ofrecidas por tu empresa?',
        min: 0,
        max: 100,
        textMin: 'Muy insatisfechos',
        textMax: 'Muy satisfechos',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          'En tu empresa, ¿Se personaliza la experiencia digital del cliente?',
        min: 0,
        max: 100,
        textMin: 'Baja personalización',
        textMax: 'Alta personalización',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">8 de cada 10 consumidores latinoamericanos (80%) ya utilizan canales digitales para sus interacciones, lo que representa un aumento del 2% con respecto al año anterior <a href="https://www.iabmexico.com/noticias/un-nuevo-informe-de-comscore-revela-que-casi-9-de-cada-10-latinoamericanos-accede-a-redes-sociales"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(iab, 2023)</a>. Las expectativas de los clientes también están creciendo. El 65% de los consumidores latinoamericanos espera experiencias personalizadas en sus interacciones digitales con las empresas <a href="https://www.salesforceben.com/growing-salesforce-career-opportunities-in-the-latam-community/"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(Salesforce, 2024)</a>. Afortunadamente, la satisfacción con las experiencias digitales en Latinoamérica también está aumentando. La satisfacción del cliente con las experiencias digitales en la región alcanzó un 75% en 2024, un 3% más que en el año anterior <a href="https://www.medallia.com/blog/medallia-experience-2024-everything-you-need-to-know/"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(Medallia, 2024)</a>. ¡Sigamos mejorando para que los clientes se sientan aún más felices!</p>',
  },
  {
    textButtom: '',
    grupo: [
      {
        title: 'Ciberseguridad, legal y RR.HH',
        tipo: 'range',
        pregunta:
          '¿En qué medida, los procesos administrativos o de apoyo empresarial (Financieros, legales, recursos humanos, otros) se encuentran digitalizados? ',
        min: 0,
        max: 100,
        textMin: 'Poco digitalizados',
        textMax: 'Muy digitalizados',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          '¿Cómo calificas el cumplimiento normativo de tu empresa en asuntos de protección de datos personales y seguridad de la información?',
        min: 0,
        max: 100,
        textMin: 'Poco',
        textMax: 'Mucho',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">Según <a href=" https://www.bnamericas.com/es/reportajes/crece-inversion-en-ciberseguridad-al-aumentar-los-ataques#:~:text=Según datos de la consultora,llegue a US%2412.480 millones"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">BNamericas (2024)</a>, se estima que la inversión en ciberseguridad en LATAM aumentará a US $8.920 millones para 2024. El aumento se puede justificar debido a que el 62% de las empresas reportaron filtraciones de datos en el último año <a href="https://www.ey.com/es_py/cybersecurity/panorama-ciberseguridad-latinoamerica-riesgos-enfrentan-empresas"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(EY, 2023)</a>, y solo el 37% de los países en la región han implementado estrategias nacionales para la transformación digital <a href=" https://www.infobae.com/america/agencias/2024/03/11/la-economia-de-latinoamerica-supera-las-expectativas-y-se-estabiliza-tras-la-pandemia"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(Infobae, 2023)</a>. Además, la escasez de talento es significativa, pues 7 de cada 10 empleadores reportando dificultades para encontrar el personal necesario <a href="https://blog.manpowergroup.com.mx/manpowergroup/eos-q3-2023"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(ManpowerGroup, 2023)</a>.</p>',
  },
  {
    textButtom: '',
    textoPosicionY: 'Personalización de la Experiencia',
    textoPosicionX: 'Búsqueda de apoyo',
    grupo: [
      {
        title: 'Soledad del líder',
        tipo: 'range',
        pregunta:
          '¿Con qué frecuencia buscas apoyo externo para manejar la soledad asociada a tu rol de liderazgo?',
        min: 0,
        max: 100,
        textMin: 'Nunca',
        textMax: 'Siempre',
        respuesta: 50,
      },
      {
        title: null,
        tipo: 'range',
        pregunta:
          '¿Qué nivel de confianza tienes en las recomendaciones que recibes de otros líderes para manejar la soledad en tu rol de liderazgo?',
        min: 0,
        max: 100,
        textMin: 'Ninguna confianza',
        textMax: 'Plena confianza',
        respuesta: 50,
      },
    ],
    textoIntermedio:
      '<p class="textoIntermedioCustom">La soledad afecta al 50% de CEOs, siendo más intensa en LATAM por sus estructuras organizacionales y culturales <a href="https://hbr.org/2020/05/how-ceos-can-lead-selflessly-through-a-crisis"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(Harvard Business Review)</a>. Los líderes digitales están cargando con una gran responsabilidad. El 78% siente una carga de trabajo excesiva <a href="https://www.ey.com/es_es/news/2022/10/los-que-lideran-grandes-cambios-transformaciones-digitales-transicion-ecologica-sector-privado"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(EY, 2022)</a>.  El 60% no se siente suficientemente apoyado por sus equipos <a href="https://www.ibm.com/blog/2022-digital-transformation-becomes-a-way-of-life/"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(IBM, 2022)</a>.  Y el 52% experimenta un sentimiento de aislamiento en su rol <a href="https://pumble.com/learn/es/communication/communication-statistics/"  class="enlacePersonalizado" target="_blank" rel="noopener noreferrer">(Pumble, 2024)</a>.  ¡Es fundamental brindar apoyo y crear un entorno de trabajo más favorable para los líderes digitales!</p>',
  },
];
export default preguntas;
